<template>
  <div class="item-container">
    <div class="item-content" :class="{ active: !isUsed }">
      <div class="item-content__index">
        <span>{{ +index + 1 }}</span>
      </div>
      <!-- <div v-if="isUsed" class="item-content__bg">
        <img :src="masterSheet?.content?.sheet_animation_image_url" />
      </div> -->
      <div class="item-content__img">
        <img
          v-if="isUsed"
          :src="masterSheet?.content?.sheet_animation_image_url"
        />
        <img v-else :src="require('@/assets/img/icon/svg/icon-emot.svg')" />
      </div>
    </div>
    <div class="item-title">
      <span>{{ displaySheetName(bookGroup, sheet) }}</span>
    </div>
    <div
      v-if="!isExpired"
      class="item-footer"
      @click="goToSheet(bookGroup, sheet)"
    >
      <button :class="{ active: !isUsed }">
        <span>{{
          isUsed
            ? $t("MyTicketTicketing.StampRally.confirm")
            : $t("MyTicketTicketing.StampRally.stamp")
        }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { computed } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ItemIndexStampTile",
  props: {
    index: {
      type: Number,
      required: true,
    },
    book: {
      type: Object,
      require: true,
    },
    sheet: {
      type: Object,
      require: true,
    },
    bookGroup: {
      type: Object,
      require: true,
    },
    isExpired: {
      type: Boolean,
      require: true,
    },
  },
  setup(props) {
    const isUsed = computed(() => !!props.sheet?.is_used);
    const masterSheet = computed(() => props.sheet._master_sheet);

    const goToSheet = (selectedBookGroup, sheet) => {
      let sheetIds = [];
      let masterSheetID = null;

      selectedBookGroup.books.forEach(function (_book) {
        _book.sheets.forEach(function (sheetEach) {
          if (sheet.master_sheet_id == sheetEach.master_sheet_id) {
            sheetIds.push(sheetEach.id);
            masterSheetID = sheetEach.master_sheet_id;
          }
        });
      });
      if (process.env.NODE_ENV == "local") {
        window.location.href = `/#/my-tickets/ticketing/${selectedBookGroup.id}/master-sheet/${masterSheetID}/sheet/${sheetIds}`;
      } else {
        nativeHandlerService.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${selectedBookGroup.id}/master-sheet/${masterSheetID}/sheet/${sheetIds}`
        );
      }
    };

    return {
      isUsed,
      goToSheet,
      masterSheet,
    };
  },
};
</script>
<style lang="scss" scoped>
.item-container {
  margin-bottom: 30px;
}

.item-content {
  padding: 50%;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  position: relative;

  &.active {
    background: #f2f2f2;
  }

  &__index {
    position: absolute;
    display: inline;
    top: 10px;
    left: 10px;
    font-size: 10px;
    font-weight: 500;
  }

  &__img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;

    > img {
      width: 100%;
      height: 100%;
    }
  }
}

.item-title {
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0;
}

.item-footer {
  button {
    width: 100%;
    border: 1px solid #fdd000;
    border-radius: 4px;
    padding: 10px;
    background: white;
    font-size: 13px;
    font-weight: 700;
    color: #000;

    &.active {
      background: #fdd000;
    }
  }
}
</style>
